import { render, staticRenderFns } from "./ReviewDetailsComments.vue?vue&type=template&id=e1942f46&scoped=true&"
import script from "./ReviewDetailsComments.vue?vue&type=script&lang=js&"
export * from "./ReviewDetailsComments.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetailsComments.vue?vue&type=style&index=0&id=e1942f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1942f46",
  null
  
)

export default component.exports